import { showTooltip } from "../store/actions/layoutActions";
import { fnLocalizeFilter, ILocale } from "./localize.service";
import { REACT_APP_BASE_URL, REACT_APP_IS_LOG_REQUEST } from "../helpers/api";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/dist/query/fetchBaseQuery";
import { getDataFromLocalStorage } from "../utils/methods";
import { userLogout } from "../store/actions/userAction";
import {ICardPurses, ICardsStatus, ICommonResponse, IResCardLimits, IResListCardLimits, IResListCardPurses, IResPurses} from "./response.interface";
import { AppDispatch } from "../store/store";
import moment from "moment";

export interface IError {
	errorCode: number;
	errorDescription: string;
}


export async function catchURLResponse<T> ( queryArg: T, { dispatch, queryFulfilled, getState }: any ) {
	const locale = getState().user.locale;

	try {
		const { data, meta } = await queryFulfilled;

		if ( REACT_APP_IS_LOG_REQUEST === 'true' ) console.log( `${ moment().format( 'DD.MM.YYYY HH:mm:ss.SS' ) } request`, {
			data,
			meta
		} );

		return data;
		// @ts-ignore
	} catch ( err: IErrorURL ) {
		if ( REACT_APP_IS_LOG_REQUEST === 'true' ) console.log( `${ moment().format( 'DD.MM.YYYY HH:mm:ss.SS' ) } request (ERROR)`, err );

		try {

			const { error: { data, status } } = err;

			let errorMessage = "";

			/* Отлавливаем ошибочный описанный статус */
			if ( [ 400, 401, 403 ].indexOf( status ) !== -1 ) {

				switch ( status ) {

					case 400: {
						errorMessage = fnLocalizeFilter( locale, `_lang.error.1005` );
						break;
					}

					case 401: {
						errorMessage = fnLocalizeFilter( locale, `_lang.error.1001` );
						dispatch( userLogout() );
						break;
					}

					case 403: {
						errorMessage = fnLocalizeFilter( locale, `_lang.error.1006` );
						break;
					}

					default : {
						errorMessage = fnLocalizeFilter( locale, `_lang.error.${ data.errorCode }` )

						/* Если ошибка не найдена, то возвращем "Неизвестную ошибку"  */
						if ( errorMessage.includes( '[Localize error]' ) ) {
							errorMessage = fnLocalizeFilter( locale, `_lang.error.1000` )
						}

						break;
					}
				}


			}

			dispatch( showTooltip( { type: "error", message: errorMessage } ) );


		} catch ( e ) {
			console.error( e );
		}

	}
}


interface ICatchResponse {
	data: ICommonResponse | any;
	dispatch: AppDispatch;
	getState: any;
	meta: any;
	isShowTooltip?: boolean;
}

export function catchResponse ( {
	                                data,
	                                meta,
	                                getState,
	                                dispatch,
	                                isShowTooltip = false
                                }: ICatchResponse ) {

	const locale = getState().user.locale;

	if ( REACT_APP_IS_LOG_REQUEST === 'true' ) console.log( `${ moment().format( 'DD.MM.YYYY HH:mm:ss.SS' ) } request`, {
		data,
		meta
	} );

	const { response: { status } } = meta;
	let errorMessage = "";


	/* Отлавливаем ошибочный описанный статус */
	if ( [ 400, 401, 403, 500 ].indexOf( status ) !== -1 ) {

		switch ( status ) {

			case 401: {
				errorMessage = fnLocalizeFilter( locale, `_lang.error.1001` );
				dispatch( userLogout() );
				break;
			}

			case 403: {
				errorMessage = fnLocalizeFilter( locale, `_lang.error.1006` );
				break;
			}

			default : {
				/* Проверяем на ошибочный ответ от сервера со статусом отличным от вышеперечисленных */
				if (data && data.errorCode ) errorMessage = fnLocalizeFilter( locale, `_lang.error.${ data.errorCode }` )

				/* Пытаемся найти ошибку в статусах отличных от вышеперечисленных */
				else if ( data.error.data.errorCode ) errorMessage = fnLocalizeFilter( locale, `_lang.error.${ data.error.data.errorCode }` )

				/* Если ошибка не найдена в указаных статусах, то возвращем "Неизвестную ошибку"  */
				else errorMessage = fnLocalizeFilter( locale, `_lang.error.1000` )
				break;
			}
		}

		status !== 401 && dispatch( showTooltip( { type: "error", message: errorMessage } ) );
		return { errorCode: 1000, errorDescription: errorMessage };

	} else {

		/* Если необходимо подтверждение */
		if ( isShowTooltip ) {
			if ( data && data.errorCode )
				errorMessage = fnLocalizeFilter( locale, `_lang.error.${ data.errorCode }` );
			else
				errorMessage = fnLocalizeFilter( locale, `_lang.error.1002` );
		}
		dispatch( showTooltip( { type: "success", message: errorMessage } ) );

		return { errorCode: 0, errorDescription: errorMessage };
	}
}

export function prepareFetchRequest (): FetchBaseQueryArgs {
	return {
		baseUrl: REACT_APP_BASE_URL,
		prepareHeaders: headers => {

			const storage = JSON.parse( getDataFromLocalStorage( 'token' ) as string );

			if ( storage && storage.token ) headers.set( `authorization`, `Bearer ${ storage && storage.token }` )
			else console.log( 'token is null' )

			return headers;

		}
	}
}

export function genNewPinCode (): string {
	const min: number = 0;
	const max: number = 9999;

	let newPinMath = Math.floor( Math.random() * ( max - min ) ) + min;
	let newPinStr = `${ newPinMath }`;


	while ( newPinStr.length <= 3 ) {
		newPinStr = '0' + newPinStr;
	}

	return newPinStr;

}

interface IGetLimits {
	data:IResCardLimits;
	dataPurses: IResListCardPurses;
	dataLimits: IResListCardLimits;
	locale: ILocale;
}
/* Парсинг ответа сервера для корректного отображения списка лимитов карты, как для водителя так и для редактирования лимитов */
export function getCardLimits({data, dataLimits, dataPurses, locale	}: IGetLimits){
	return data.limits = data.limits.map(limit => {

		const listPursesId = limit.attachedPurses.map(purse => purse.purseId);

		let currentPurse: ICardPurses[] = dataPurses.purses && dataPurses.purses.filter(purse => listPursesId.indexOf(purse.purseId) !== -1) || [];

		let listPurses = currentPurse.map(purse => purse.remark);
		if (!listPurses) listPurses = [''];

		const typeSchema = currentPurse[0]?.purseTypeId === 0
			? fnLocalizeFilter(locale, '_lang.module.cards.limits.titleShortMoneySchema')
			: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleShortQtySchema');

		let limitType: ICardsStatus = dataLimits && dataLimits.types.find(type => (limit.limitType === type.id)) || {
			id: 0, remark: ''
		};

		let rest = limit.limitAmount - limit.limitBalance;

		return {
			...limit,
			purses: listPurses.join(', '),
			type: limitType.remark,
			typeSchema: typeSchema,
			qtyLimit: limit.limitAmount,
			balance: limit.limitBalance,
			rest: rest > 0 ? rest.toFixed(2) : 0
		}
	})
}
